import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";
import React from "react";
import decodeHTMLEntities from "core-web/utils/decodeHTMLEntities";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const PaginationMeta = ({ hitsCount, seen, current = 0, total = 0 }) => {
    const { t } = useTranslation();
    const application = useSelector(({ application }) => application);
    const page = useSelector(({ page }) => page);

    const subDesc = (string) => {
        return string
            .replace(/<\/{0,1}[^>]+>/g, "")
            .slice(0, 152)
            .concat("...");
    };

    const getUrls = () => {
        let next, prev;

        if (page.data) {
            const protocol = application.protocol ? application.protocol : "";
            const origin = application.origin ? application.origin : "";
            const baseUrl = protocol + origin;
            const data = page.data;
            const currentPage = current + 1;

            const url = baseUrl + data.permalink.toLowerCase();

            if (currentPage > 0 && currentPage < total) {
                next = `${url}?page=${currentPage + 1}`;
            }

            if (currentPage > 1) {
                prev = `${url}?page=${currentPage - 1}`;
            }
        }

        return {
            next,
            prev,
        };
    };

    const getDescription = () => {
        if (page.data) {
            const data = page.data;
            const title = page.data.title;
            const currentPage = current + 1;
            const description = data.seo.description ? data.seo.description : data.seo.og_description;

            if (currentPage > 1) {
                let paginationDescription = `${t("page")} ${currentPage} ${t("for")} ${title}. ${t(
                    "shows_product",
                )} ${seen} ${t("out_of")} ${hitsCount}. ${description}`;
                paginationDescription = decodeHTMLEntities(paginationDescription);
                paginationDescription = subDesc(paginationDescription);

                return paginationDescription;
            }
        }
        return null;
    };

    const urls = getUrls();
    const getDesc = getDescription();

    return (
        <Helmet>
            {getDesc && <meta name="description" content={getDesc} />}
            {urls.prev !== undefined && <link href={urls.prev.replace(/\?page=1$/, "")} rel="prev" />}
            {urls.next !== undefined && <link href={urls.next} rel="next" />}
        </Helmet>
    );
};

PaginationMeta.propTypes = {
    current: PropTypes.number,
    hitsCount: PropTypes.number,
    seen: PropTypes.number,
    total: PropTypes.number,
};

PaginationMeta.defaultProps = {
    current: 0,
    hitsCount: null,
    seen: null,
    total: 0,
};

export default PaginationMeta;
